export default __webpack_public_path__ + "static/media/36.75268fc8.png";